import { apiClient } from '@/lib/api/client';
export const passengerDocumentsApi = {
    async listByPassenger(passengerId) {
        const { data } = await apiClient.get(`/api/v1/passengers/${passengerId}/documents`);
        return data;
    },
    async upload(passengerId, dto, file) {
        if (file) {
            const formData = new FormData();
            formData.append('documentTypeId', dto.documentTypeId);
            formData.append('file', file);
            const { data } = await apiClient.post(`/api/v1/passengers/${passengerId}/documents`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return data;
        }
        else {
            const { data } = await apiClient.post(`/api/v1/passengers/${passengerId}/documents`, { documentTypeId: dto.documentTypeId, url: dto.url ?? '' });
            return data;
        }
    },
    async delete(passengerId, documentId) {
        await apiClient.delete(`/api/v1/passengers/${passengerId}/documents/${documentId}`);
    },
    getDownloadUrl(passengerId, documentId) {
        const base = import.meta.env.VITE_API_URL ?? '/';
        return `${base}api/v1/passengers/${passengerId}/documents/${documentId}/download`;
    },
};
// Portal endpoints
export const portalDocumentsApi = {
    async getMyDocuments(token, tenantSlug) {
        const base = import.meta.env.VITE_API_URL ?? '/';
        const res = await fetch(`${base}api/v1/portal/me/documents`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'x-tenant-slug': tenantSlug,
            },
        });
        if (!res.ok)
            throw new Error(`Failed to load documents: ${res.status}`);
        return res.json();
    },
    getDownloadUrl(documentId, token, tenantSlug) {
        const base = import.meta.env.VITE_API_URL ?? '/';
        return `${base}api/v1/portal/documents/${documentId}/download?token=${encodeURIComponent(token)}&tenant=${encodeURIComponent(tenantSlug)}`;
    },
};
//# sourceMappingURL=passengerDocuments.js.map